import React, {memo, useCallback, useMemo} from 'react';
import PropTypes from 'prop-types';
import {InFilter} from '@dofleini/query-builder';
import map from 'lodash/map';
import {Tag} from 'antd';
import {useGetAllRegisters} from '@/modules/registers/hooks/useRegisters';

const additionalParams = {
  useProjections: true,
  projections: {
    name: 1,
    category: 1,
  }
};

const UserRegistersAccessRegistersCell = ({entity}) => {

  const registersFilter = useMemo(() => {
    return new InFilter({field: '_id', value: entity?.registers}).toQuery();
  }, [entity]);

  const {data: registers} = useGetAllRegisters(registersFilter, additionalParams);

  const tagsRender = useCallback((value) => {
    return (<div className='flex flex-wrap'>
      {map(value, (item) => (
        <div key={`tag-${item['_id']}`} className="pb-2">
          <Tag className="px-2 py-1">
            <div className='flex flex-col'>
              <span>{item['name']}</span>
            </div>

          </Tag>
        </div>
      ))}
    </div>);
  }, []);
  
  return (
    // <Link to={`${ROUTE_PATH_NOMENCLATURES_SERVICES_CATEGORY}/${entity._id}`}>
    tagsRender(registers)
    // </Link>
  );
};

UserRegistersAccessRegistersCell.propTypes = {
  entity: PropTypes.object,
};
UserRegistersAccessRegistersCell.defaultProps = {
  entity: {},
};

export default memo(UserRegistersAccessRegistersCell);


/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Email component in a table cell
 * @param {String} text this is the value of the dataIndex of the table (we will ignored in this case)
 * @param {Object} entity this is the row instance
 * */
export const renderUserRegistersAccessRegistersCell = (text, entity) => {
  return (
    <UserRegistersAccessRegistersCell entity={entity}/>
  );
};

